import InstagramTemplate from '../components/instagramTemplate';

export default InstagramTemplate;